<template>
  <div class="filters-page">
    <vuestic-widget :headerText="$t('reports.headings.filters')">
      <div class="row">
        <div class="col-md-12">
          <div slot="body">
            <div class="row filters-page__filter-bar-container">
              <div class="form-group">
                <div class="input-group">
                  <vuestic-date-picker
                    id="tripDurationFrom"
                    v-validate="'required'"
                    data-vv-name="durationFrom"
                    v-model="durationFrom"
                    :config="dateConfig"
                  />
                  <label
                    class="control-label"
                    for="tripDurationFrom"
                  >{{ $t('trip.create.durationFrom') }}</label>
                  <i class="bar"></i>
                </div>
              </div>

              <div class="form-group">
                <div class="input-group">
                  <vuestic-date-picker
                    id="tripDurationTo"
                    v-validate="'required'"
                    data-vv-name="durationTo"
                    v-model="durationTo"
                    :config="dateConfig"
                  />
                  <label
                    class="control-label"
                    for="tripDurationTo"
                  >{{ $t('trip.create.durationTo') }}</label>
                  <i class="bar"></i>
                </div>
              </div> 

              <!-- <filter-bar v-model="name" class="filters-page__filter-bar" label="Name" /> -->
              <!-- <filter-bar v-model="email" class="filters-page__filter-bar" label="Email" /> -->
              <vuestic-simple-select
                class="filters-page__filter-bar"
                :label="$t('reports.headings.tripDestinationType')"
                option-key="name"
                v-model="countryOption"
                :options="countryList"
              />
              <vuestic-simple-select
                class="filters-page__filter-bar"
                :label="$t('reports.headings.paymentType')"
                option-key="name"
                v-model="paymentTypeOption"
                :options="paymentTypes"
              />
              
            </div>
          </div>
          <div class="filters-page__tags">
            <!-- <vuestic-tag v-if="name" :name="`Name: ${ name }`" removable @remove="name = ''" /> -->
            <!-- <vuestic-tag v-if="email" :name="`Email: ${ email }`" removable @remove="email = ''" /> -->
            <vuestic-tag v-if="country" :name="`${$t('reports.headings.tripDestinationType')}: ${ countryLabel(country) }`" removable @remove="resetCountry()" />
            <vuestic-tag v-if="paymentType" :name="`${$t('reports.headings.paymentType')}: ${ paymentTypeLabel(paymentType) }`" removable @remove="resetPaymentType()" />
            <span
              v-if="this.country || this.paymentType"
              class="filters-page__clear-all-text"
              @click="clearAll"
            >{{'general.clearall' | translate}}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <download-csv
          :data   = "sortedItemsJSON"
          :fields = "csvFields">
          <button
            class="btn btn-secondary btn-micro">{{'traveller.download' | translate}}</button>
          <!-- <img src="download_icon.png"> -->
      </download-csv>
      </div>
    </vuestic-widget>
    <vuestic-widget>
      <div class="table-responsive">
        <table class="table table-striped first-td-padding">
          <thead>
            <tr>
              <!-- <td
                class="filters-page__table-heading"
                @click="sortBy('key')"
              >{{ $t('reports.headings.key') }}</td> -->
              <td
                class="filters-page__table-heading"
                @click="sortBy('personName')"
              >{{ $t('reports.headings.personName') }}</td>

              <td
                class="filters-page__table-heading"
                @click="sortBy('tripTitle')"
              >{{ $t('reports.headings.tripTitle') }}</td>


              <td
                class="filters-page__table-heading"
                @click="sortBy('date')"
              >{{ $t('reports.headings.date') }}</td>

              

              <td
                class="filters-page__table-heading"
                @click="sortBy('amount')"
              >{{ $t('reports.headings.amount') }}</td>

              <td
                class="filters-page__table-heading"
                @click="sortBy('amount')"
              >{{ $t('reports.headings.paymentType') }}</td>

              
              <!-- <td
                class="filters-page__table-heading"
                @click="sortBy('tripKey')"
              >{{ $t('reports.headings.tripKey') }}</td> -->

              <!-- <td
                class="filters-page__table-heading"
                @click="sortBy('tripStartDate')"
              >{{ $t('reports.headings.tripStartDate') }}</td>

              <td
                class="filters-page__table-heading"
                @click="sortBy('tripEndDate')"
              >{{ $t('reports.headings.tripEndDate') }}</td> -->

              <td
                class="filters-page__table-heading"
                @click="sortBy('tripDestinationType')"
              >{{ $t('reports.headings.tripDestinationType') }}</td>


<!-- 
              <td
                class="filters-page__table-heading"
                @click="sortBy('personIdentityNumber')"
              >{{ $t('reports.headings.personIdentityNumber') }}</td> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in sortedItems" v-bind:key="item.key">
              <!-- <td>{{ item.key }}</td> -->
              <td>{{ item.personName }}</td>
              <td>{{ item.tripTitle }}, {{ item.tripKey }}, ({{dateToLocal(item.tripStartDate)}} - {{dateToLocal(item.tripEndDate)}})</td>
              <td>{{ dateToLocal(item.date) }}</td>
              <td>{{ item.amount }}</td>
              <td>{{ paymentTypeLabel(item.paymentType) }}</td>
              
              
              <!-- <td></td> -->
              <!-- <td>{{ dateToLocal(item.tripStartDate)}}</td> -->
              <!-- <td /> -->
              <!-- <td>{{ dateToLocal(item.tripEndDate) }}</td> -->
              <!-- <td />   -->
              <td align="center">{{ countryLabel(item.tripDestinationType) }}</td>
              <!-- <td>{{ item.personIdentityNumber }}</td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </vuestic-widget>
  </div>
</template>

<script>
import VuesticWidget from "../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
import FilterBar from "../../../vuestic-theme/vuestic-components/vuestic-datatable/datatable-components/FilterBar.vue";
import VuesticSimpleSelect from "../../../vuestic-theme/vuestic-components/vuestic-simple-select/VuesticSimpleSelect";
import { SpringSpinner } from "epic-spinners";
import { itemList } from "./filtersData";
import { reportsApi } from "../../../services/api/reportsApi";
import moment from 'moment';
import { dateLocale, dateLocaleBG, serverDateLocale } from "../../../utils"
import { XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx"


export default {
  name: "filters",
  components: {
    VuesticWidget,
    FilterBar,
    SpringSpinner,
    VuesticSimpleSelect,
     XlsxWorkbook,
    XlsxSheet,
    XlsxDownload
  },
  created: function() {
    this.fetchReport()
  },
  data() {
    return {
      isLoading: false,
      name: "",
      email: "",
      country: "",
      paymentType: "",
      paymentTypeOption: null,
      csvFields: ["име", "пътуване", "дата", "сума",  "метод", "държава"],
      countryOption: { id: "", name: this.$t("general.destination.all") },
      countryList: [
        { id: "EU", name: this.$t("general.destination.EU") },
        { id: "BG", name: this.$t("general.destination.BG") },
        { id: "OT", name: this.$t("general.destination.OT") },
        { id: "", name: this.$t("general.destination.all") }
      ],
      paymentTypes: [
        { id: "P", name: this.$t("payment.type.pos") },
        { id: "B", name: this.$t("payment.type.bank") },
        { id: "D", name: this.$t("payment.type.protocol") },
        { id: "V", name: this.$t("payment.type.vaucher") },
        { id: "C", name: this.$t("payment.type.cash") }
      ],
      itemList: itemList,
      items: [],
      currentSort: "name",
      currentSortDir: "asc",
      durationFrom: moment().subtract(7, 'days').format(dateLocale),
      durationTo: moment().format(dateLocale),
      dateConfig: {
        dateFormat: "d.m.Y",
        locale: { firstDayOfWeek: 1 }
      },
      countryLabelMap: {
        "EU" : this.$t("general.destination.EU"),
        "BG" : this.$t("general.destination.BG"),
        "OT": this.$t("general.destination.OT")
      },
      paymentTypesMap: {
        "P": this.$t("payment.type.pos"),
        "B": this.$t("payment.type.bank"),
        "D": this.$t("payment.type.protocol"),
        "V": this.$t("payment.type.vaucher"),
        "C": this.$t("payment.type.cash") 
        },
        sheetName: null,
      sheets: [{ name: "SheetOne", data: [{ c: 2, r:3, v: "Hello" }] }],
      collection: [{ a: 1, b: 2 }],
      download: true
    };
  },
  watch: {
    paymentTypeOption: {
      handler() {
        this.paymentType = this.paymentTypeOption.id
      },
    },
    countryOption: {
      handler() {
        this.country = this.countryOption.id
      },
    },
    durationFrom: {
      handler() {
        this.fetchReport()
      },
    },
    durationTo: {
      handler() {
        this.fetchReport()
      },
    },
  },
  methods: {
    clearAll() {
      this.name = "";
      this.email = "";
      this.countryOption = { id: "", name: this.$t("general.destination.all") };
      this.country = "";
      this.paymentType = "";
    },
    fetchReport() {
      this.isLoading = true;
      var from = moment(this.durationFrom, dateLocale).format(serverDateLocale)
      var to = moment(this.durationTo, dateLocale).format(serverDateLocale)
      reportsApi.all(from, to)
        .then(rows => {
          this.items = rows
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    resetCountry() {
      this.countryOption = { id: "", name: this.$t("general.destination.all") };
      this.country = "";
    },
    resetPaymentType() {
      this.paymentTypeOption = null
      this.paymentType = ""
    },
    sortBy(name) {
      console.log("Sort by: ", name)
      if (name === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = name;
    },
    countryLabel: function (key) {
      return this.countryLabelMap[key]
    },
    paymentTypeLabel: function (key) {
      return this.paymentTypesMap[key]
    },
    dateToLocal: function (date) {
      return moment(date, serverDateLocale).format(dateLocaleBG);
    },
    addSheet() {
      this.sheets.push({ name: this.sheetName, data: [...this.collection] });
      this.sheetName = null;
    }
  },
  computed: {
    sortedItems: function() {
      let filteredItems = this.items;
      // if (this.name) {
      //   filteredItems = filteredItems.filter(
      //     item => item.name.toUpperCase().search(this.name.toUpperCase()) !== -1
      //   );
      // }
      // if (this.email) {
      //   filteredItems = filteredItems.filter(
      //     item =>
      //       item.email.toUpperCase().search(this.email.toUpperCase()) !== -1
      //   );
      // }
      if (this.country) {
        filteredItems = filteredItems.filter(
          item => item.tripDestinationType.toUpperCase().search(this.country.toUpperCase()) !== -1
        );
      }

      if (this.paymentType) {
        filteredItems = filteredItems.filter(
          item => item.paymentType.toUpperCase().search(this.paymentType.toUpperCase()) !== -1
        );
      }

      return filteredItems.sort((a, b) => {
        let field = this.currentSort
        let modifier = 1;
        if (this.currentSortDir === "desc") modifier = -1;

        if (typeof a[field] === 'string') {
          return modifier * ('' + a[field]).localeCompare(b[field]);
        }
        if (a[field] < b[field]) return -1 * modifier;
        if (a[field] > b[field]) return 1 * modifier;
        return 0;
      });
    },

    sortedItemsJSON: function() {
      let json = this.sortedItems;

      let items = json.map(item => {
        let newObj = {}
        newObj["ключ"] = item.key
        newObj["сума"] = item.amount
        newObj["метод"] = this.paymentTypeLabel(item.paymentType)
        newObj["дата"] = this.dateToLocal(item.date)
        newObj["пътуване"] = item.tripTitle + ", " + item.tripKey + ", (" + this.dateToLocal(item.tripStartDate) + " - " + this.dateToLocal(item.tripEndDate) + ")"
        newObj["държава"] = this.countryLabel(item.tripDestinationType)
        newObj["име"] = item.personName
        newObj["егн"] = item.personIdentityNumber      
        return newObj
      })

      return items
    }
  }
};
</script>

<style lang="scss">
.filters-page {
  &__tags {
    display: flex;
  }
  &__filter-bar {
    width: 300px;
  }
  &__filter-bar-container {
    margin: 0;
    justify-content: space-between;
  }
  &__table-heading {
    color: $vue-green;
  }
  &__collapse {
    .vuestic-collapse__body {
      background-color: white;
    }
  }
  &__clear-all-text {
    cursor: pointer;
    color: $vue-green;
    margin-top: 0.3rem;
  }
}
</style>
